import React, { useEffect } from 'react';
import Header from '../../../headerone/Main';
import Bredcom from '../../../Bredcom/Main';
import LicenseRenewalDetails from '../../subdepartmentdetails/LicenseRenewal';

function LicenseRenewal() {
  useEffect(() => {
    document.getElementById("title").innerHTML = "Driver’s License Renewal || Motor Vehicles";
  }, []);

  return (
    <>
      {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

      <div className="page-wrapper">
        <Bredcom 
          subtitle="Motor Vehicles"
          title="Driver’s License Renewal"
          subtitledown="Department of Motor Vehicles"
        />
        <LicenseRenewalDetails />
      </div>
    </>
  );
}

export default LicenseRenewal;
